//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/tooltip'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { EventsNames } from '../../../helpers/events-names'


//#region Asset Imports

import './info-tooltip.scss'
import * as TEMPLATE from './info-tooltip.tpl.html'

//#endregion

export interface Source {
    icon: string
    tooltipText: string
}

interface InfoTooltipScope extends ng.IScope {
    source: Source

    iconId: number
    tooltipText: string
    tooltipVisible: boolean

    showTooltip()
    tooltipOptions: DevExpress.ui.dxTooltipOptions
}

export class InfoTooltipDirective implements ng.IDirective {
    constructor() {

    }
    scope = {
        source: '='
    }
    restrict = 'E'

    private wasResized = false

    controller = ['$scope', '$q', '$timeout', '$http', 'logger', 'localDictionary', 'api', ($scope: InfoTooltipScope, $q: ng.IQService, $timeout: ng.ITimeoutService, $http: ng.IHttpService, logger: LoggerService, localDictionary: LocalDictionaryFactory, api: Api) => {
        $scope.iconId = new Date().getTime()
        $scope.tooltipText = $scope.source.tooltipText
        if (this.wasResized)
            $scope.tooltipVisible = false
        else
            $scope.tooltipVisible = true;

        $scope.showTooltip = function () {
            $scope.tooltipVisible = true;
        }

        $scope.tooltipOptions = {
            target: '#iconTooltip' + $scope.iconId,
            bindingOptions: {
                visible: 'tooltipVisible'
            },
            position: window['config'].RTLSTATE == false ? 'right' : 'left'
        }

        $scope.$on(EventsNames.WINDOW_RESIZED, () => {
            this.wasResized = true
        })

    }]
    template = TEMPLATE
    replace = true
}